export default Object.freeze({
  Pending: 1, // "pending"
  InProgress: 2, // "in-progress"
  Blocked: 3, // "blocked"
  OnHold: 4, // "on-hold"
  Completed: 5, // "completed"
  Canceled: 6, // "canceled"
  Failed: 7, // "failed"
});
